import { createSelector } from 'reselect';
import { getOperators } from 'lib/selectors/getOperators';
import { getIsLaborTicketEnabled } from './getIsLaborTicketEnabled';

const defaultActiveOperators = [];

/**
 * If ldFlag is true, returns active MAPPED operators.
 * Otherwise, only returns active operators.
 */
const getActiveOperators = createSelector(
  [getOperators, getIsLaborTicketEnabled],
  (operators, isLaborTicketEnabled) => {
    if (operators?.length > 0) {
      return operators?.filter((operator) => {
        if (isLaborTicketEnabled) {
          return !operator.archivedAt && operator?.erpId;
        }
        return !operator.archivedAt;
      });
    }
    return defaultActiveOperators;
  }
);

const getHasUnmappedActiveOperators = createSelector(
  [getOperators, getIsLaborTicketEnabled],
  (operators, isLaborTicketEnabled) => {
    const noOperators = operators?.length === 0;
    // return early if no operators or labor ticket is disabled
    if (noOperators || !isLaborTicketEnabled) {
      return false;
    }

    const unMappedActiveOperator = operators.find((operator) => {
      return !operator.erpId && !operator.archivedAt;
    });
    return !!unMappedActiveOperator;
  }
);

export { getActiveOperators, getHasUnmappedActiveOperators };
